import React, { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeaderTop from './components/Header/headerTop';
import Footer from './components/Footer/footer';
import Loader from './components/Loader/loader';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './components/ScrollToTop/scrollToTop';
import PageNotFound from './pages/404/404';
import ErrorBoundaryWrapper from './components/ErrorBoundary/errorBoundary';

const HomePage = lazy(() => import('./pages/Home/homePage'));
const ContactPage = lazy(() => import('./pages/Contact/contactPage'));
// const BlogPage = lazy(() => import('./pages/Blog/blog'));
// const CaseStudyPage = lazy(() => import('./pages/CaseStudy/caseStudy'));
// const EventPage = lazy(() => import('./pages/Event/eventPage'));
const SolutionPage = lazy(() => import('./pages/Solutions/solutionPage'));
const InformationSecurityPage = lazy(() =>
  import('./pages/Service/InformationSecurityPage/informationSecurity')
);
const FinancialImprovementPage = lazy(() =>
  import('./pages/Service/FinancialImprovementPage/financialImprovement')
);
const CarrierServicePage = lazy(() =>
  import('./pages/Service/CarrierServicesPage/carrierService')
);
const FraudManagementPage = lazy(() =>
  import('./pages/Service/FraudManagementPage/farudManagement')
);
const RevenueAssurancePage = lazy(() =>
  import('./pages/Service/RevenueAssurancePage/revenueAssurance')
);
const MaturityAssessmentPage = lazy(() =>
  import('./pages/Service/MaturityAssessment/maturityAssessment')
);

const ItServicesPage = lazy(() =>
  import('./pages/Service/ItServices/itServcies')
);

function App() {
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setShowHeader(false); // Hide header when scrolling down
      } else if (currentScrollY < lastScrollY) {
        setShowHeader(true); // Show header when scrolling up
      }
      setLastScrollY(currentScrollY);
    };
  
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);
  
  return (
    <Router>
      <ScrollToTop />
      <>
        <div
          className={`fixed top-0 left-0 w-full z-50 transform transition-transform duration-300 ${
            showHeader ? 'translate-y-0' : '-translate-y-full'
          }`}
        >
          <HeaderTop />
        </div>
        <ErrorBoundaryWrapper>
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              {/* <Route path="/case-study" element={<CaseStudyPage />} /> */}
              {/* <Route path="/blog" element={<BlogPage />} /> */}
              <Route path="/contact" element={<ContactPage />} />
              {/* <Route path="/events" element={<EventPage />} /> */}
              <Route path="/solution/:solutionId" element={<SolutionPage />} />
              <Route
                path="/services/information-security"
                element={<InformationSecurityPage />}
              />
              <Route
                path="/services/financial-improvement"
                element={<FinancialImprovementPage />}
              />
              <Route
                path="/services/carrier-services"
                element={<CarrierServicePage />}
              />
              <Route
                path="/services/fraud-management"
                element={<FraudManagementPage />}
              />
              <Route
                path="/services/revenue-assurance"
                element={<RevenueAssurancePage />}
              />
              <Route
                path="/services/maturity-assessment"
                element={<MaturityAssessmentPage />}
              />
              <Route
                path="/services/itservices"
                element={<ItServicesPage />}
              />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </Suspense>
        </ErrorBoundaryWrapper>
        <Footer />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </>
    </Router>
  );
}

export default App;
